import type { FunctionComponent } from 'react';

export const CommuteSearchCTAImage: FunctionComponent<{ className: string }> = ({ className }) => (
  <svg
    className={className}
    width={612}
    height={116}
    viewBox="0 0 612 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_45783_11480)">
      <g clipPath="url(#clip1_45783_11480)">
        <rect width={611} height={116} transform="translate(1)" fill="#F2F4F7" />
        <path
          d="M212 70.5L285.669 101.906C299.395 107.758 314.809 108.285 328.903 103.385L469.5 54.5"
          stroke="white"
          strokeWidth={18}
        />
        <path d="M198.5 102.5L108.5 38" stroke="white" strokeWidth={18} />
        <path d="M163 2L100 42.5" stroke="white" strokeWidth={6} />
        <path
          d="M388.5 -9L257.063 38.2035C238.269 44.9528 217.35 41.9104 201.258 30.0876L153.5 -5"
          stroke="white"
          strokeWidth={18}
        />
        <path d="M240 -9L187 132.5" stroke="white" strokeWidth={18} />
        <path d="M354 -7L401.5 121" stroke="white" strokeWidth={18} />
        <path
          d="M264 -7.5L280.192 30.6677C283.273 37.9288 283.37 46.111 280.462 53.443L250.5 129"
          stroke="white"
          strokeWidth={18}
        />
        <path d="M205.5 32.5L97.5 112" stroke="white" strokeWidth={18} />
        <path d="M198 103L52 -2" stroke="white" strokeWidth={18} />
        <path d="M131 138L-15 33" stroke="white" strokeWidth={18} />
        <path d="M163 2L107 38" stroke="white" strokeWidth={6} />
        <path d="M92 27L33.5 66.5" stroke="white" strokeWidth={6} />
        <path d="M122.5 48.5L64.5 89.5" stroke="white" strokeWidth={6} />
        <path d="M114 -28L-51 78" stroke="white" strokeWidth={18} />
        <path d="M522 -24L573 116.5" stroke="white" strokeWidth={18} />
        <path
          d="M441 -14L461.109 40.7975C472.216 71.0639 505.256 87.1424 535.927 77.2068L623 49"
          stroke="white"
          strokeWidth={18}
        />
        <path
          d="M399.5 -5.5L426.222 66.0976C443.097 111.31 492.628 135.166 538.499 120.175L614 95.5"
          stroke="white"
          strokeWidth={6}
        />
        <path
          d="M471 -48L494.46 15.906C500.015 31.0361 516.531 39.0737 531.865 34.1083L623 4.59633"
          stroke="white"
          strokeWidth={6}
        />
        <path d="M47 77L-2 108" stroke="white" strokeWidth={18} />
        <path d="M97 -9L179 51" stroke="white" strokeWidth={6} />
        <path d="M176 87L141 131.5" stroke="white" strokeWidth={6} />
        <path d="M211 70L179 52.5" stroke="white" strokeWidth={6} />
        <path d="M125 90L176 126" stroke="white" strokeWidth={6} />
        <path d="M-20 -12L32 25" stroke="white" strokeWidth={6} />
        <path d="M-30 65L114.5 166" stroke="white" strokeWidth={6} />
        <path d="M219.5 130.5L254.5 40" stroke="white" strokeWidth={6} />
        <path d="M197.5 101L251.5 123" stroke="white" strokeWidth={6} />
        <path d="M373 43L502.5 -2.5" stroke="white" strokeWidth={6} />
        <path
          d="M310 0.5L329.678 57C329.678 57 329.678 57 329.678 57C329.678 57 348.463 110.939 360.5 145.5"
          stroke="white"
          strokeWidth={6}
        />
        <path d="M272 77L373 43" stroke="white" strokeWidth={6} />
        <path d="M566 -24L617 116.5" stroke="white" strokeWidth={6} />
        <path d="M501.5 78.5L487 148" stroke="white" strokeWidth={6} />
        <path d="M485.5 69.5L508 33" stroke="white" strokeWidth={6} />
        <path
          d="M441 -14L461.109 40.7975C472.216 71.0639 505.256 87.1424 535.927 77.2068L623 49"
          stroke="#DFE4E8"
          strokeWidth={7}
        />
        <path d="M47 77L-2 108" stroke="#DFE4E8" strokeWidth={7} />
        <path
          d="M212 70.5L285.665 101.904C299.393 107.757 314.81 108.283 328.906 103.381L468 55"
          stroke="#DFE4E8"
          strokeWidth={7}
        />
        <path d="M198 103L52 -2" stroke="#DFE4E8" strokeWidth={7} />
        <path d="M131 138L-15 33" stroke="#DFE4E8" strokeWidth={7} />
        <path d="M114 -28L-51 78" stroke="#DFE4E8" strokeWidth={7} />
        <path d="M522 -24L573 116.5" stroke="#DFE4E8" strokeWidth={7} />
        <path
          d="M388.5 -9L257.063 38.2035C238.269 44.9528 217.35 41.9104 201.258 30.0876L153.5 -5"
          stroke="#DFE4E8"
          strokeWidth={7}
        />
        <path d="M240 -9L187 132.5" stroke="#DFE4E8" strokeWidth={7} />
        <path d="M354 -7L401.5 121" stroke="#DFE4E8" strokeWidth={7} />
        <path
          d="M264 -7.5L280.192 30.6677C283.273 37.9288 283.37 46.111 280.462 53.443L250.5 129"
          stroke="#DFE4E8"
          strokeWidth={7}
        />
        <path d="M205 32L84 122" stroke="#DFE4E8" strokeWidth={7} />
        <g
          style={{
            mixBlendMode: 'darken',
          }}
        >
          <rect x={1} width={611} height={116} fill="#E799FF" fillOpacity={0.4} />
        </g>
      </g>
      <g filter="url(#filter0_ddd_45783_11480)">
        <rect
          x={259.5}
          y={19}
          width={93}
          height={30}
          rx={8}
          fill="#0F9469"
          shapeRendering="crispEdges"
        />
        <rect
          x={258.25}
          y={17.75}
          width={95.5}
          height={32.5}
          rx={9.25}
          stroke="white"
          strokeWidth={2.5}
          shapeRendering="crispEdges"
        />
        <path
          d="M305.616 57.8839L306.5 58.7678L307.384 57.8839L315.384 49.8839L317.518 47.75H314.5H298.5H295.482L297.616 49.8839L305.616 57.8839Z"
          fill="white"
          stroke="white"
          strokeWidth={2.5}
        />
        <rect x={259.5} y={19} width={93} height={30} rx={8} fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M277.459 26.75C275.672 26.75 274.133 28.0117 273.782 29.7646L273.332 32.0157C272.687 32.3759 272.25 33.0655 272.25 33.8571V36.5C272.25 37.7587 273.094 38.8222 274.25 39.1476V39.5C274.25 40.4665 275.034 41.25 276 41.25H277C277.966 41.25 278.75 40.4665 278.75 39.5V39.25H280.25V39.5C280.25 40.4665 281.034 41.25 282 41.25H283C283.967 41.25 284.75 40.4665 284.75 39.5V39.1473C285.906 38.8217 286.75 37.7588 286.75 36.5V33.8571C286.75 33.0655 286.313 32.3759 285.668 32.0157L285.218 29.7646C284.867 28.0117 283.328 26.75 281.541 26.75H277.459ZM285.055 33.4116C284.876 33.514 284.649 33.6159 284.362 33.7115C283.505 33.9974 282.039 34.25 279.5 34.25C276.961 34.25 275.495 33.9974 274.638 33.7115C274.351 33.6159 274.124 33.514 273.945 33.4116C273.825 33.5225 273.75 33.6811 273.75 33.8571V36.5C273.75 37.1924 274.308 37.75 274.996 37.75H275H278H281H284H284.003C284.692 37.75 285.25 37.1919 285.25 36.5V33.8571C285.25 33.6811 285.175 33.5225 285.055 33.4116ZM283.25 39.25H281.75V39.5C281.75 39.6381 281.862 39.75 282 39.75H283C283.138 39.75 283.25 39.6381 283.25 39.5V39.25ZM277.25 39.25H275.75V39.5C275.75 39.6381 275.862 39.75 276 39.75H277C277.138 39.75 277.25 39.6381 277.25 39.5V39.25ZM275.112 32.2885C274.995 32.2495 274.902 32.2125 274.829 32.1795L275.253 30.0587C275.463 29.007 276.387 28.25 277.459 28.25H281.541C282.613 28.25 283.537 29.007 283.747 30.0587L284.171 32.1795C284.098 32.2125 284.005 32.2495 283.888 32.2885C283.245 32.5026 281.961 32.75 279.5 32.75C277.039 32.75 275.755 32.5026 275.112 32.2885ZM277.5 36C277.5 36.5523 277.052 37 276.5 37C275.948 37 275.5 36.5523 275.5 36C275.5 35.4477 275.948 35 276.5 35C277.052 35 277.5 35.4477 277.5 36ZM282.5 37C283.052 37 283.5 36.5523 283.5 36C283.5 35.4477 283.052 35 282.5 35C281.948 35 281.5 35.4477 281.5 36C281.5 36.5523 281.948 37 282.5 37Z"
          fill="#3C3D43"
        />
        <path
          d="M292.589 29.2H295.753V39H293.919V30.852H292.589V29.2ZM301.415 32.686C303.445 32.686 304.453 34.324 304.453 35.808C304.453 37.964 302.717 39.168 300.757 39.168C299.259 39.168 298.195 38.594 297.411 37.418L298.755 36.368C299.315 37.11 299.945 37.474 300.799 37.474C301.877 37.474 302.507 36.83 302.507 35.892C302.507 34.926 301.877 34.282 300.855 34.282C300.337 34.282 299.819 34.45 299.455 34.954H297.901L298.839 29.2H304.201V30.852H300.267L299.889 33.176C300.309 32.854 300.813 32.686 301.415 32.686ZM317.266 31.622C318.694 31.622 319.758 32.658 319.758 34.24V39H317.952V34.604C317.952 33.694 317.476 33.19 316.832 33.19C316.062 33.19 315.502 33.722 315.502 34.66V39H313.696V34.604C313.696 33.694 313.22 33.19 312.576 33.19C311.806 33.19 311.246 33.722 311.246 34.66V39H309.44V31.79H311.246V32.686C311.652 31.944 312.324 31.622 313.108 31.622C314.004 31.622 314.76 32.056 315.166 32.812C315.6 31.972 316.356 31.622 317.266 31.622ZM322.559 30.684C321.915 30.684 321.397 30.292 321.397 29.606C321.397 28.934 321.915 28.514 322.559 28.514C323.203 28.514 323.721 28.934 323.721 29.606C323.721 30.292 323.203 30.684 322.559 30.684ZM321.649 31.79H323.455V39H321.649V31.79ZM329.189 31.622C330.659 31.622 331.751 32.7 331.751 34.352V39H329.945V34.66C329.945 33.722 329.413 33.19 328.685 33.19C327.831 33.19 327.215 33.764 327.215 34.758V39H325.409V31.79H327.215V32.728C327.649 31.944 328.377 31.622 329.189 31.622ZM336.355 39.168C334.871 39.168 333.681 38.58 333.233 37.432L334.563 36.662C334.913 37.348 335.445 37.712 336.355 37.712C337.195 37.712 337.699 37.446 337.699 37.012C337.699 36.592 337.307 36.41 336.425 36.186L335.725 36.018C334.101 35.612 333.415 34.912 333.415 33.778C333.415 32.49 334.535 31.622 336.285 31.622C337.825 31.622 338.833 32.28 339.351 33.372L337.909 34.044C337.601 33.4 337.013 33.092 336.285 33.092C335.557 33.092 335.123 33.372 335.123 33.736C335.123 34.198 335.641 34.366 336.439 34.562L337.153 34.744C338.665 35.108 339.421 35.836 339.421 36.928C339.421 38.258 338.203 39.168 336.355 39.168Z"
          fill="#3C3D43"
        />
      </g>
      <g filter="url(#filter1_dd_45783_11480)">
        <circle cx={587} cy={85} r={8} fill="#3C3D43" />
        <circle cx={587} cy={85} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter2_dd_45783_11480)">
        <circle cx={79} cy={57} r={8} fill="#3C3D43" />
        <circle cx={79} cy={57} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter3_dd_45783_11480)">
        <circle cx={27} cy={-1} r={8} fill="#3C3D43" />
        <circle cx={27} cy={-1} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter4_dd_45783_11480)">
        <circle cx={520} cy={54} r={8} fill="#3C3D43" />
        <circle cx={520} cy={54} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter5_dd_45783_11480)">
        <circle cx={154} cy={94} r={8} fill="#3C3D43" />
        <circle cx={154} cy={94} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter6_dd_45783_11480)">
        <circle cx={418} cy={17} r={8} fill="#3C3D43" />
        <circle cx={418} cy={17} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter7_dd_45783_11480)">
        <circle cx={204} cy={51} r={8} fill="#3C3D43" />
        <circle cx={204} cy={51} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter8_dd_45783_11480)">
        <circle cx={401} cy={51} r={8} fill="#3C3D43" />
        <circle cx={401} cy={51} r={9} stroke="white" strokeWidth={2} />
      </g>
      <g filter="url(#filter9_dd_45783_11480)">
        <circle cx={252} cy={2} r={8} fill="#3C3D43" />
        <circle cx={252} cy={2} r={9} stroke="white" strokeWidth={2} />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ddd_45783_11480"
        x={232}
        y={-4.5}
        width={148}
        height={94.0356}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={12.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.14902 0 0 0 0 0.160784 0 0 0 0 0.168627 0 0 0 0.15 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.14902 0 0 0 0 0.160784 0 0 0 0 0.168627 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.14902 0 0 0 0 0.160784 0 0 0 0 0.168627 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_45783_11480"
          result="effect3_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_45783_11480"
        x={575}
        y={73}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_45783_11480"
        x={67}
        y={45}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dd_45783_11480"
        x={15}
        y={-13}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_dd_45783_11480"
        x={508}
        y={42}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_dd_45783_11480"
        x={142}
        y={82}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_dd_45783_11480"
        x={406}
        y={5}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_dd_45783_11480"
        x={192}
        y={39}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_dd_45783_11480"
        x={389}
        y={39}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_dd_45783_11480"
        x={240}
        y={-10}
        width={24}
        height={24}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.719097 0 0 0 0 0.748125 0 0 0 0 0.791667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_45783_11480" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.74902 0 0 0 0 0.792157 0 0 0 0.55 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_45783_11480"
          result="effect2_dropShadow_45783_11480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_45783_11480"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_45783_11480">
        <rect width={612} height={116} rx={6} fill="white" />
      </clipPath>
      <clipPath id="clip1_45783_11480">
        <rect width={611} height={116} fill="white" transform="translate(1)" />
      </clipPath>
    </defs>
  </svg>
);
